/**
 * Description: 推荐订单
 * User: 常胤 <satans17@gmail.com>
 * Date: 14-10-20
 * Copyright(c) 2014 Taobao.com
 */

import events from 'events';
import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui/index';
import orderTemplate from './tpl.html';

import './style.scss';

const LOG_C = 'recommendorder';

export default class TopOrder extends events {

  constructor(config) {
    super();
    this.app = config.app;
    this.selfShow = false;
    this.$container = null;
    this.config = config;
    this.selfConfig = null;
  }

  render() {
    const $n = this.$container = $('<div class="m-chatpanel-toporder-asyn"><div class="card-loading"></div></div>');
    $(this.config.container).append($n);
    const $cardLoading = $n.find('.card-loading');
    $cardLoading.addClass('loading');
    this.app.model.getTopOrder({
      from: this.config.from || 'unknown',
    }).then((data) => {
      const $no = $(orderTemplate.render({
        list: data,
      }));
      $cardLoading.removeClass('loading');
      $n.append($no);
      const $container = $n.find('.order-container');
      for (let i = 0; i < data.length; i++) {
        this.orderConventer(data[i]);
        const $node = BaseUI.orderItem(data[i]);
        $container.append($node);
      }
      this.bindEvt();
    }, (err) => {
      console.log(err);
    });
  }

  htmlEncode(str) {
    let s = '';
    if (!str) return null;
    if (str.length === 0) return null;
    s = str.replace(/&amp;/g, '&');
    s = s.replace(/&lt;/g, '<');
    s = s.replace(/&gt;/g, '>');
    s = s.replace(/&nbsp;/g, ' ');
    s = s.replace(/&#39;/g, '\'');
    s = s.replace(/&quot;/g, '\"');
    s = s.replace(/&mdash;/g, '—');
    return s;
  }

  formatSKU(option) {
    const d = option;
    const sku = d.split('|')[1];
    const skus = sku.split(';');
    const formatedSKU = [];
    for (let i = 0; i < skus.length; i++) {
      const key = skus[i].split(':')[0];

      if (key.indexOf('颜色') >= 0 || key === '尺寸') {
        formatedSKU.push(skus[i]);
      }
    }
    return formatedSKU.join(';');
  }

  orderConventer(item) {
    item.title = this.htmlEncode(item.title);
    if (item.attributes && item.attributes.sku) {
      item.attributes.sku = this.formatSKU(item.attributes.sku);
    }
    item.json = JSON.stringify(item);
  }

  updateConfig(data) {
    this.selfConfig = data;
  }

  bindEvt() {
    const app = this.app;

    this.$container.on('swipeUp', () => {
      app.orderList.show({
        source: 'toporder',
      });
      this.app.log.send({
        c: LOG_C,
        d: 'swipeall',
      });
    });

    this.$container.find('.J_Order').on('tap', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      const id = $(ev.currentTarget).attr('data-id');
      const json = $(ev.currentTarget).attr('data-json');
      const index = this.$container.find('.J_Item').index($(ev.currentTarget));
      // 进入机器人流程,需要显示快捷短语
      app.emit(app.events.ORDER_SELECT, {
        id,
        source: 'toporder',
        order: JSON.parse(json),
      });
      this.config.inputPanel.resize();
      const ext = {};
      ext.position = index;
      this.app.log.send({
        c: LOG_C,
        d: 'order',
        ext: JSON.stringify(ext),
      });
    });

    this.$container.find('.J_AllItem').on('tap', () => {
      app.orderList.show({
        source: 'toporder',
      });
      this.app.log.send({
        c: LOG_C,
        d: 'all',
      });
    });
  }

  show() {
    if (!this.selfShow) {
      this.render();
      this.selfShow = true;
    } else {
      this.$container.show();
    }
    this.emit('show');
  }

  hide() {
    if (this.$container) {
      this.emit('hide');
      this.$container.hide();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/module/topOrder/index.js